import { render, staticRenderFns } from "./tabFixturePreview.vue?vue&type=template&id=325c9b16&"
import script from "./tabFixturePreview.vue?vue&type=script&lang=js&"
export * from "./tabFixturePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports